/* ============
 * Globally accessible helper functions
 * ============
 *
 */

import Vue from 'vue'
import helpers from '@/app/helpers'

Vue.$helpers = helpers
Object.defineProperty(Vue.prototype, '$helpers', {
  get () {
    return helpers
  }
})



// WEBPACK FOOTER //
// ./src/app/plugins/helpers.js